import { useCallback, useEffect, useState, useRef } from "react";
import useColumn from "../../../utils/customHooks/useColumns";
import { successToast, errorToast } from "../../../utils/toastHelper";
import { useNavigate } from "react-router-dom";
import usePageState from "../../../utils/customHooks/usePageState";
import { STAUTES } from "../../../utils/constant";
import { GET_RAP_INFOS, DELETE_RAP_INFO } from "../../../utils/services/apiPath";
import { deleteApi, postApi } from "../../../utils/services";
import { useTheme } from "../../ContextStore/ThemeContext";
import { useDispatch, useSelector } from "react-redux";
import { handleLogout, userSelector } from "../../store/features/auth/authSlice";
import logo from "../../Assets/Icons/logo.png";
import logoWhite from "../../Assets/Icons/logo-white.png";
import menuopen from "../../Assets/Icons/menu-open.png";
import menuclose from "../../Assets/Icons/menu-close.png";
import NotificationIcon from "../../Assets/IconComponents/Notification";
import { headerMenus } from "../../../utils/MenusConfig";
import HelpMenu from "../../Components/Header/HelpMenu";
import { ProGrid, NameCell, DeleteCell, Layout } from "@proscore-ai/proscore-ui-library";
import useCsvExport from "../../../utils/useCsvExporter";

const getRedirectUrl = params => {
  return `/rap-info/${params.id}`;
};

export default function RapList() {
  const navigate = useNavigate();
  const { theme } = useTheme();
  const [menuOpen, setMenuOpen] = useState(false);
  const [popOverOpen, setPopOverOpen] = useState(false);
  const ref = useRef(null);
  const userData = useSelector(userSelector);
  const dispatch = useDispatch();

  const handleTabClick = tab => {
    navigate(`${tab.to}`);
  };
  const handleMenuOpen = () => setMenuOpen(!menuOpen);

  const onLogout = () => {
    dispatch(handleLogout());
  };

  const manageAccount = () => {
    setPopOverOpen(false);
  };

  const handleHome = () => {
    navigate("/clients");
  };
  const {
    currentPage,
    pageSize,
    data: rapData,
    rowCount,
    status,
    sortModel,
    searchString,
    setPageState,
    setPagination,
    setStatus,
    setSortModel,
    setSearchString
  } = usePageState();
  const columns = useColumn(
    [
      {
        field: "approvedJobTitle",
        headerName: "Approved Labor Classification Title",
        renderCell: params => <NameCell params={params} getRedirectUrl={getRedirectUrl} />
      },
      {
        field: "industryName",
        headerName: "Industry"
      },
      {
        field: "categoryName",
        headerName: "Category"
      },
      {
        field: "rapidCode",
        headerName: "RAPIDS Code"
      },
      {
        field: "programLengthYears",
        headerName: "Program Length"
      },
      {
        field: "rapInfoGuid",
        headerName: "Actions",
        isDeleteColumn: true,
        disableExport: true,
        width: 80,
        renderCell: params => <DeleteCell title={"Delete Rap Info"} params={params} onDelete={onDelete} />
      }
    ],
    true
  );

  const onDelete = async id => {
    const { error } = await deleteApi(DELETE_RAP_INFO, { params: { rapInfoId: id } });
    if (error) return errorToast(error);
    successToast("Rap Info deleted successfully.");
    getRapInfoList();
  };

  const addButtonAction = () => {
    navigate("/rap-info/add");
  };

  const getRapInfoList = useCallback(async () => {
    setStatus(STAUTES.LOADING);
    const payload = {
      pageIndex: searchString ? 1 : currentPage + 1,
      pageSize: pageSize,
      searchString: searchString,
      orderByAscending: true,
      ...sortModel
    };
    const { data, totalRecords, error } = await postApi(GET_RAP_INFOS, payload);
    setStatus(STAUTES.IDLE);
    if (error) return errorToast(error);
    setPageState(prevPageInfo => ({ ...prevPageInfo, data: data || [], rowCount: totalRecords }));
  }, [currentPage, pageSize, sortModel, searchString, setPageState, setStatus]);

  const handleDownloadCSV = useCsvExport({
    api: GET_RAP_INFOS,

    getPayload: () => {
      const activeSort = sortModel?.[0] || {
        field: "approvedJobTitle",
        sort: "asc"
      };

      return {
        pageIndex: 1,
        pageSize: rowCount || 10000,
        searchString,
        orderByAscending: activeSort.sort === "asc",
        orderCol: activeSort.field
      };
    },

    mapData: data =>
      data.map(item => ({
        "Approved Labor Classification Title": item.approvedJobTitle || "",
        "Industry": item.industryName || "",
        "Category": item.categoryName || "",
        "RAPIDS Code": item.rapidCode || "",
        "Program Length": item.programLengthYears || ""
      })),

    fileName: "RapInfoList.csv"
  });

  useEffect(() => {
    getRapInfoList();
  }, [getRapInfoList]);

  return (
    <Layout
    theme={theme}
    user={{
      userName: userData?.userName,
      email: userData?.email,
      avatar: userData?.avatar
    }}
    onLogout={onLogout}
    onTabClick={handleTabClick}
    onLogoClick={handleHome}
    logo={logo}
    logoWhite={logoWhite}
    menuOpenIcon={menuopen}
    menuCloseIcon={menuclose}
    menuTabs={headerMenus}
    NotificationIcon={NotificationIcon}
    HelpComponent={HelpMenu}
    >
      <ProGrid
        title="Rap Info"
        loading={status === STAUTES.LOADING}
        options={{
          getRowId: row => row.rapInfoGuid,
          rowCount: rowCount,
          paginationMode: "server",
          paginationModel: { pageSize: pageSize, page: currentPage },
          onPaginationModelChange: setPagination,
          sortingMode: "server",
          onSortModelChange: setSortModel
        }}
        columns={columns}
        hideAddButton={false}
        hideExport={false}
        rows={rapData}
        searchMode={!!searchString}
        searchModel={{ defaultValue: searchString, handleDebounce: setSearchString }}
        addButtonLabel="+ Add Rap Info"
        addButtonAction={addButtonAction}
        exportAction={handleDownloadCSV}
      />
    </Layout>
  );
}
